// extracted by mini-css-extract-plugin
export default {"backLink":"GamesBackLink_backLink__v89Lz"};